// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"180":"video","594":"about"}[chunkId] + "." + {"180":"feac2aad","594":"c455d1c4"}[chunkId] + ".css";
};